import { render, staticRenderFns } from "./distributionClient.vue?vue&type=template&id=006b3cf1&scoped=true"
import script from "./distributionClient.vue?vue&type=script&lang=js"
export * from "./distributionClient.vue?vue&type=script&lang=js"
import style0 from "./distributionClient.vue?vue&type=style&index=0&id=006b3cf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b3cf1",
  null
  
)

export default component.exports